export default __webpack_public_path__ + "static/media/Medical_research.27f86d83.svg";